(function () {
'use strict';

function getBaseClass(block, element) {
  return !element ? block : block + '__' + element;
}

function addModifier(baseClass, modifier) {
  return modifier ? baseClass + '--' + modifier : null;
}

function getClassArray(block, element) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var baseClass = getBaseClass(block, element);
  var modifierFn = addModifier.bind(null, baseClass);
  return [baseClass].concat(modifiers.map(modifierFn)).filter(function (c) {
    return c;
  });
}

function getClassesAsString(block, element, modifiers) {
  return getClassArray(block, element, modifiers).join(' ');
}

function bemmit(block) {
  return getClassesAsString.bind(null, block);
}

module.exports = bemmit;

}());
